var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcLightRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc_light-rain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.32,35.75a8,8,0,0,0-10.47-7.63,10.22,10.22,0,1,0-20.2,3h-1.9a6.32,6.32,0,0,0,0,12.63H50a6.27,6.27,0,0,0,4.67-2.09A8,8,0,0,0,57.32,35.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46,50.31a2.34,2.34,0,1,1-4.3-1.76c.63-1.55,3.72-2.6,3.61-2.69S46.61,48.76,46,50.31Zm-8.48-4.45c.11.09-3,1.14-3.61,2.69a2.34,2.34,0,1,0,4.31,1.76C38.82,48.76,37.35,45.85,37.49,45.86Zm-7.78,0c.1.09-3,1.14-3.61,2.69a2.34,2.34,0,1,0,4.3,1.76C31,48.76,29.56,45.85,29.71,45.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,1.17A36.13,36.13,0,1,0,73.9,37.3,36.17,36.17,0,0,0,37.78,1.17Zm0,70.25A34.13,34.13,0,1,1,71.9,37.3,34.17,34.17,0,0,1,37.78,71.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcLightRain);
export default __webpack_public_path__ + "static/media/dc_light-rain.6bc2df0f9bff0b07f06874004662cc47.svg";
export { ForwardRef as ReactComponent };